import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';

interface AutoCompletePhoneNumberResponse {
	phoneNumber: string;
	createdAt: number;
	uuid: string;
	ttl: number;
}

@Injectable()
export class AutoCompletePhoneNumberService {
    constructor(
        private http: HttpClient,
    ) { }

	async get_phone_number(phone_number_uuid: string): Promise<AutoCompletePhoneNumberResponse | false> {
		try { 
			const data = await (new Promise<AutoCompletePhoneNumberResponse>((resolve, reject) => {
				this.http
					.get<AutoCompletePhoneNumberResponse>(`https://pedir-delivery-autocomplete-phone-number.lambda.multipedidos.com.br/item/${phone_number_uuid}`)
					.subscribe(
						(data) => resolve(data),
						(error) => reject(error)
					);
			}));

			// createdAt em ms (ex.: 1755316372486). Aceita createdAt ou created_at.
			const createdAtRaw = (data as any)?.createdAt ?? (data as any)?.created_at;
			const createdAtMs = Number(createdAtRaw);

			if (!Number.isFinite(createdAtMs)) return false;

			const FIVE_MIN_MS = 5 * 60 * 1000;
			const isExpired = (Date.now() - createdAtMs) > FIVE_MIN_MS;

			if (isExpired) return false;

			return data;
		} catch (e) {
			console.error('Error fetching phone number:', e);
			return false;
		}
	}
}